import firebase from "firebase";
import store from "@/store"
import userModules from "@/store/modules/assessment/RegisterModules.js";
import adminModules from "@/store/modules/system/RegisterModules.js";

const actions = {
  //TODO - This would be replaced by acting directly on the watched db
  togglePinned( {state}, {collection, id, key, sub_id}){
    var item = state[collection].find( i => i.id == id );
    if( key ){
      var sub_iem = item[key].find( s => s.id == sub_id  );
      sub_iem.pinned = !sub_iem.pinned;
    }
    else{
      item.pinned = !item.pinned;
    }
  },
  triggerRegisterModules({dispatch}, view){
    var registerModules = false;
    if( view == "user" ){
      registerModules = userModules
    }
    if( view == "admin" ){
      registerModules = adminModules
    }
    if( !store.hasModule("registerModules") ){
      store.registerModule("registerModules", registerModules);
      dispatch("registerModules")
    }
  },
  updateDoc({state},{ doc, action, data}){
    state;
    const db = firebase.firestore();
    return new Promise((resolve, reject) => {
      if( action == "delete" ){
        db.doc(doc)[action]().then( ref => {
          resolve(ref)
        }).catch( err => {
          reject(err)
        })
      }
      else{

        let now = firebase.firestore.Timestamp.fromDate(new Date());
        data.updated = now;
        delete data.bound;
        db.doc(doc)[action](data).then( ref => {
          resolve(ref)
        }).catch( err => {
          reject(err)
        })
      }
    })
  }, 
  addDoc({state},{ collection, data}){
    state;
    const db = firebase.firestore();
    return new Promise((resolve, reject) => {
      let now = firebase.firestore.Timestamp.fromDate(new Date());
      data.created = now;
      data.updated = now;
      db.collection(collection).add(data).then( ref => {
        resolve(ref)
      }).catch( err => {
        reject(err)
      })
    })
  },
  getDoc({state},{ doc }){
    state;
    const db = firebase.firestore();
    return new Promise((resolve, reject) => {
      db.doc(doc).get().then( ref => {
        if( !ref.exists ){
          resolve(false);
        }
        let result = ref.data();
        result.id = ref.id;
        resolve(result)
      }).catch( err => {
        reject(err)
      })
    })
  }
};

export default actions;